import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router';

const BackLink = ({text="Back", redirectUrl=null, replace=false, className=null}) => {
  const navigate = useNavigate();

  return (
    <a
      href="#"
      onClick={(e) => {
        e.preventDefault();
        if (redirectUrl) {
          navigate(redirectUrl, { replace });
        } else {
          navigate(-1);
        }
      }}
      className={`text-primary hover:underline mb-4 inline-flex items-center ${className}`}
    >
      <ArrowLeft className="w-4 h-4 mr-2" /> {text}
    </a>
  );
};

export default BackLink;
